var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "cargo-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      staticClass: "app-main-inner write-off-detail-dialog",
      attrs: {
        visible: _vm.innerVisible,
        "close-on-click-modal": false,
        title: this.$t("CargoMsg.Cargo_WriteOffDetails"),
        width: "1200px",
        "can-maximize": true,
        "can-minimize": true
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        },
        fullscreen: function(p) {
          _vm.isMax = p
        },
        close: _vm.cancel
      }
    },
    [
      _c(
        "div",
        { staticClass: "tabs-container" },
        [
          _c(
            "el-tabs",
            {
              attrs: { "active-name": _vm.activeTabName },
              on: { "tab-click": _vm.handleClick }
            },
            [
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    label: _vm.$t("CargoMsg.Cargo_WriteOff"),
                    name: "applicationForm"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "app-main-inner-row row-grid",
                      style: _vm.isMax
                        ? "width:100%;height:100%"
                        : "width:100%;height:320px"
                    },
                    [
                      _c("cargo-ag-grid", {
                        attrs: {
                          "config-module": "180601",
                          "grid-params": _vm.gridParams,
                          "grid-options": _vm.gridOptions,
                          "column-defs": _vm.finalColumnDefs,
                          "row-data": _vm.rowData,
                          "row-clicked": _vm.rowClicked
                        },
                        on: {
                          "update:gridParams": function($event) {
                            _vm.gridParams = $event
                          },
                          "update:grid-params": function($event) {
                            _vm.gridParams = $event
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "app-main-inner-row",
                      style: _vm.isMax ? "height:30%" : "height:180px"
                    },
                    [
                      _c(
                        "el-form",
                        {
                          attrs: {
                            inline: true,
                            disabled: "",
                            "label-width": _vm.$selectByLang("65px", "80px"),
                            "label-position": "left"
                          }
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "el-form-item-wrapper" },
                            [
                              _c(
                                "el-form-item",
                                [
                                  _c("line-label", {
                                    attrs: {
                                      slot: "label",
                                      label: _vm.receiveTypeLabel
                                    },
                                    slot: "label"
                                  }),
                                  _c("cargo-advance-select", {
                                    staticStyle: { width: "120px" },
                                    attrs: {
                                      filterable: "",
                                      no: "1",
                                      "select-type":
                                        _vm.selectTypeNames
                                          .local_cache_ClearingConstants$AMOUNT_RECEIVE_TYPES,
                                      "callback-method-type": "value",
                                      "default-value": _vm.type,
                                      "callback-params": { key: "receiveType" },
                                      clearable: false
                                    },
                                    on: {
                                      parentCallBack:
                                        _vm.getReceiveTypesFromChild
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                [
                                  _c("line-label", {
                                    attrs: {
                                      slot: "label",
                                      label: _vm.$t(
                                        "WriteOff.bankReceiptStatus"
                                      )
                                    },
                                    slot: "label"
                                  }),
                                  _c("cargo-advance-select", {
                                    staticStyle: { width: "120px" },
                                    attrs: {
                                      filterable: "",
                                      no: "2",
                                      "default-value": _vm.cashTransferState,
                                      "static-options":
                                        _vm.cashTransferStateArray,
                                      "tag-value": "code"
                                    },
                                    on: {
                                      parentCallBack:
                                        _vm.getCashTransferStateFromChild
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                [
                                  _c("line-label", {
                                    attrs: {
                                      slot: "label",
                                      label: _vm.$t("WriteOff.ourSideBank")
                                    },
                                    slot: "label"
                                  }),
                                  _c("el-select", {
                                    staticStyle: { width: "150px" },
                                    attrs: { no: "3", value: _vm.ourBankValue }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                [
                                  _c("line-label", {
                                    attrs: {
                                      slot: "label",
                                      label: _vm.$t("WriteOff.ourSideAccount")
                                    },
                                    slot: "label"
                                  }),
                                  _c("el-input", {
                                    staticStyle: { width: "160px" },
                                    attrs: { no: "4" },
                                    model: {
                                      value: _vm.ourBankAccountNo,
                                      callback: function($$v) {
                                        _vm.ourBankAccountNo = $$v
                                      },
                                      expression: "ourBankAccountNo"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                [
                                  _c("line-label", {
                                    attrs: {
                                      slot: "label",
                                      label: _vm.$t("WriteOff.proofNo")
                                    },
                                    slot: "label"
                                  }),
                                  _c("el-input", {
                                    staticStyle: { width: "150px" },
                                    attrs: { no: "5" },
                                    model: {
                                      value: _vm.voucherNo,
                                      callback: function($$v) {
                                        _vm.voucherNo = $$v
                                      },
                                      expression: "voucherNo"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "el-form-item-wrapper" },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: { label: _vm.$t("WriteOff.currency") }
                                },
                                [
                                  _c("cargo-advance-select", {
                                    staticStyle: { width: "120px" },
                                    attrs: {
                                      filterable: "",
                                      no: "6",
                                      "select-type":
                                        _vm.selectTypeNames.basic_data_Currency,
                                      "default-value": _vm.currency,
                                      clearable: false
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "custom-el-form-item-color-red"
                                },
                                [
                                  _c("line-label", {
                                    attrs: {
                                      slot: "label",
                                      label: _vm.amountLabel
                                    },
                                    slot: "label"
                                  }),
                                  _c("el-input", {
                                    staticStyle: { width: "120px" },
                                    attrs: {
                                      value: _vm.formatVerfiedAmount,
                                      no: "7"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                [
                                  _c("line-label", {
                                    attrs: {
                                      slot: "label",
                                      label: _vm.$t(
                                        "WriteOff.theOppositeSideCompany"
                                      )
                                    },
                                    slot: "label"
                                  }),
                                  _c("el-input", {
                                    staticStyle: { width: "150px" },
                                    attrs: { no: "8" },
                                    model: {
                                      value: _vm.paymentCompany,
                                      callback: function($$v) {
                                        _vm.paymentCompany = $$v
                                      },
                                      expression: "paymentCompany"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                [
                                  _c("line-label", {
                                    attrs: {
                                      slot: "label",
                                      label: _vm.$t(
                                        "WriteOff.theOppositeSideBank"
                                      )
                                    },
                                    slot: "label"
                                  }),
                                  _c("el-input", {
                                    staticStyle: { width: "160px" },
                                    attrs: { no: "9" },
                                    model: {
                                      value: _vm.companyBank,
                                      callback: function($$v) {
                                        _vm.companyBank = $$v
                                      },
                                      expression: "companyBank"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                [
                                  _c("line-label", {
                                    attrs: {
                                      slot: "label",
                                      label: _vm.$t(
                                        "WriteOff.theOppositeSideAccount"
                                      )
                                    },
                                    slot: "label"
                                  }),
                                  _c("el-input", {
                                    staticStyle: { width: "150px" },
                                    attrs: { no: "10" },
                                    model: {
                                      value: _vm.companyBankAccount,
                                      callback: function($$v) {
                                        _vm.companyBankAccount = $$v
                                      },
                                      expression: "companyBankAccount"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "el-form-item-wrapper" },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "custom-el-form-item-color-green"
                                },
                                [
                                  _c("line-label", {
                                    attrs: {
                                      slot: "label",
                                      label: _vm.$t(
                                        "WriteOff.exchangeGainsAndLosses"
                                      )
                                    },
                                    slot: "label"
                                  }),
                                  _c("el-input-number", {
                                    staticStyle: { width: "120px" },
                                    attrs: {
                                      no: "11",
                                      "controls-position": "right",
                                      precision: 2
                                    },
                                    model: {
                                      value: _vm.nsDiffChange,
                                      callback: function($$v) {
                                        _vm.nsDiffChange = $$v
                                      },
                                      expression: "nsDiffChange"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "custom-el-form-item-color-green"
                                },
                                [
                                  _c("line-label", {
                                    attrs: {
                                      slot: "label",
                                      label: _vm.$t("WriteOff.financialCharges")
                                    },
                                    slot: "label"
                                  }),
                                  _c("el-input-number", {
                                    staticStyle: { width: "120px" },
                                    attrs: {
                                      no: "12",
                                      "controls-position": "right",
                                      precision: 2
                                    },
                                    model: {
                                      value: _vm.nsFinancialCost,
                                      callback: function($$v) {
                                        _vm.nsFinancialCost = $$v
                                      },
                                      expression: "nsFinancialCost"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  staticClass:
                                    "custom-el-form-item-color-green",
                                  attrs: { label: _vm.$t("WriteOff.oddment") }
                                },
                                [
                                  _c("el-input-number", {
                                    staticStyle: { width: "120px" },
                                    attrs: {
                                      no: "13",
                                      "controls-position": "right",
                                      precision: 2
                                    },
                                    model: {
                                      value: _vm.nsClearOdd,
                                      callback: function($$v) {
                                        _vm.nsClearOdd = $$v
                                      },
                                      expression: "nsClearOdd"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  staticClass:
                                    "custom-el-form-item-color-green remark",
                                  attrs: { label: _vm.$t("WriteOff.remark") }
                                },
                                [
                                  _c("cargo-rich-textarea", {
                                    attrs: {
                                      no: "14",
                                      "text-chars": 0,
                                      "warning-count": -1,
                                      disabled: true,
                                      "single-line": true
                                    },
                                    nativeOn: {
                                      dblclick: function($event) {
                                        _vm.showAdvanceTextDialog(
                                          _vm.$t("WriteOff.remark"),
                                          _vm.remark
                                        )
                                      }
                                    },
                                    model: {
                                      value: _vm.remark,
                                      callback: function($$v) {
                                        _vm.remark = $$v
                                      },
                                      expression: "remark"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                [
                                  _c("line-label", {
                                    attrs: {
                                      slot: "label",
                                      label: _vm.$t("Payment.preRemarks")
                                    },
                                    slot: "label"
                                  }),
                                  _c("el-input", {
                                    staticStyle: { width: "150px" },
                                    attrs: { no: "5" },
                                    model: {
                                      value: _vm.preRemark,
                                      callback: function($$v) {
                                        _vm.preRemark = $$v
                                      },
                                      expression: "preRemark"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                [
                                  _c("line-label", {
                                    attrs: {
                                      slot: "label",
                                      label: _vm.$t(
                                        "CargoMsg.Cargo_WriteOffHeader"
                                      )
                                    },
                                    slot: "label"
                                  }),
                                  _c("el-input", {
                                    staticStyle: { width: "150px" },
                                    attrs: { no: "actualAmountTitle" },
                                    model: {
                                      value: _vm.actualAmountTitle,
                                      callback: function($$v) {
                                        _vm.actualAmountTitle = $$v
                                      },
                                      expression: "actualAmountTitle"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c("el-form-item", [
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      color: "#1a61af",
                                      "font-weight": "bold"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("WriteOff.thisTimeWriteOff") +
                                          "=" +
                                          _vm.amountLabel +
                                          "+" +
                                          _vm.$t(
                                            "WriteOff.exchangeGainsAndLosses"
                                          ) +
                                          "+" +
                                          _vm.$t("WriteOff.financialCharges") +
                                          "+" +
                                          _vm.$t("WriteOff.oddment")
                                      )
                                    )
                                  ]
                                )
                              ])
                            ],
                            1
                          ),
                          _vm.showWhtAmount
                            ? _c(
                                "div",
                                { staticClass: "el-form-item-wrapper" },
                                [
                                  _c(
                                    "el-form-item",
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "Clearing.WhtDeductionAmount"
                                            )
                                          )
                                        )
                                      ]),
                                      _c("el-input", {
                                        staticStyle: {
                                          width: "120px",
                                          "margin-left": "10px"
                                        },
                                        attrs: {
                                          value: _vm.whtAmount.toFixed(2),
                                          disabled: ""
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ]
                      )
                    ],
                    1
                  )
                ]
              ),
              _c(
                "el-tab-pane",
                {
                  staticStyle: { height: "503px" },
                  attrs: {
                    label: _vm.$t("CargoMsg.Cargo_FileHistory"),
                    name: "fileHistory",
                    lazy: true
                  }
                },
                [
                  _vm.actualAmount && _vm.actualAmount.uuid
                    ? _c("file-history", {
                        attrs: {
                          uuid: _vm.actualAmount.uuid,
                          state: 0,
                          "input-by": _vm.$store.getters.userId,
                          "grid-height": "416px",
                          "module-name": "writeOff"
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("div", { attrs: { slot: "footer" }, slot: "footer" }, [
        _c(
          "span",
          {
            staticStyle: {
              position: "absolute",
              left: "0",
              "padding-left": "10px"
            }
          },
          [
            _c("span", [_vm._v(_vm._s(_vm.$t("WriteOff.totalWriteOffs")))]),
            _c("charge-currency-total-group", {
              attrs: {
                "ar-field": "ar",
                "currency-field": "clearCurrency",
                "data-field": "clearAmount",
                type: "revenueAbs",
                "data-provider": _vm.totalGroup,
                "amount-to-currency-label": _vm.$t("WriteOff.totalWriteOffs")
              }
            }),
            _c("span", [_vm._v(_vm._s(_vm.$t("WriteOff.totalEquivalent")))]),
            _vm.reCalc
              ? _c("charge-currency-total-group", {
                  attrs: {
                    "ar-field": "ar",
                    "currency-field": "currency",
                    "data-field": "amount",
                    "amount-to-currency": _vm.localCurrency,
                    "rate-field": "rate",
                    type: "revenueAbs",
                    "amount-to-currency-label": _vm.$t("Clearing.Equivalent"),
                    "data-provider": _vm.totalGroup2
                  }
                })
              : _vm._e()
          ],
          1
        ),
        _c(
          "span",
          [
            _c(
              "el-button-group",
              [
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.activeTabName === "applicationForm",
                        expression: "activeTabName==='applicationForm'"
                      },
                      {
                        name: "permission",
                        rawName: "v-permission",
                        value: ["button_ACWriteoff_approve"],
                        expression: "['button_ACWriteoff_approve']"
                      }
                    ],
                    attrs: { type: "primary", no: "15" },
                    on: { click: _vm.approveHandler }
                  },
                  [_vm._v(_vm._s(_vm.$t("WriteOff.recheck")))]
                ),
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.activeTabName === "applicationForm",
                        expression: "activeTabName==='applicationForm'"
                      }
                    ],
                    attrs: { type: "primary", no: "16" },
                    on: { click: _vm.onExport }
                  },
                  [
                    _c("svg-icon", {
                      staticStyle: {
                        "font-size": "12px",
                        "vertical-align": "bottom"
                      },
                      attrs: { "icon-class": "excel" }
                    }),
                    _vm._v(_vm._s(_vm.$t("WriteOff.exportToExcel")))
                  ],
                  1
                ),
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.activeTabName === "applicationForm",
                        expression: "activeTabName==='applicationForm'"
                      }
                    ],
                    attrs: { type: "primary", no: "17" },
                    on: { click: _vm.onExportPdf }
                  },
                  [
                    _c("svg-icon", {
                      staticStyle: {
                        "font-size": "12px",
                        "vertical-align": "bottom"
                      },
                      attrs: { "icon-class": "excel" }
                    }),
                    _vm._v(_vm._s(_vm.$t("WriteOff.exportPDF")))
                  ],
                  1
                ),
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.activeTabName === "applicationForm",
                        expression: "activeTabName==='applicationForm'"
                      }
                    ],
                    attrs: { type: "primary", no: "18" },
                    on: { click: _vm.onPrint }
                  },
                  [_vm._v(_vm._s(_vm.$t("WriteOff.print")))]
                ),
                _c(
                  "el-button",
                  { attrs: { no: "19" }, on: { click: _vm.cancel } },
                  [_vm._v(_vm._s(_vm.$t("WriteOff.close")))]
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _c("cargo-template-selector-dialog", {
        attrs: {
          visible: _vm.templateSelectorDialog.visible,
          ctx: _vm.templateSelectorDialog.cxt,
          category: _vm.templateSelectorDialog.category,
          data: _vm.templateSelectorDialog.data
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.templateSelectorDialog, "visible", $event)
          }
        }
      }),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            no: "advanceTextDialog",
            visible: _vm.advanceTextDialog.visible,
            title: _vm.advanceTextDialog.title,
            width: "600px",
            "close-on-click-modal": false,
            "close-on-press-escape": true,
            "append-to-body": true
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.advanceTextDialog, "visible", $event)
            }
          }
        },
        [
          _c("cargo-rich-textarea", {
            ref: "advanceTextDialogTextarea",
            staticStyle: { height: "320px" },
            attrs: {
              no: "advanceTextDialogTextarea",
              disabled: true,
              "text-chars": _vm.advanceTextDialog.formatObj.maxChar,
              "warning-count": _vm.advanceTextDialog.formatObj.warningCount,
              "auto-half-word": _vm.advanceTextDialog.formatObj.autoHalfWord,
              "auto-uppercase": _vm.advanceTextDialog.formatObj.autoUppercase
            },
            model: {
              value: _vm.advanceTextDialog.value,
              callback: function($$v) {
                _vm.$set(_vm.advanceTextDialog, "value", $$v)
              },
              expression: "advanceTextDialog.value"
            }
          }),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { no: "advanceTextDialogClose" },
                  on: {
                    click: function($event) {
                      _vm.advanceTextDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.close")))]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }